export const red = '#DE513E'
export const greyText = '#808285'